import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LeatherVest = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.LeatherVest.itemName}
      name={SS23.tops.LeatherVest.itemName}
      price={SS23.tops.LeatherVest.itemPrice}
      fabric={SS23.tops.LeatherVest.itemFabric}
      src={SS23.tops.LeatherVest.sizeChart}
      divId={SS23.tops.LeatherVest.shopifyDivId}
      mainId={SS23.tops.LeatherVest.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.LeatherVest.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.LeatherVest.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LeatherVest;
